<template>
    <div>
      <header>
        <h1>Priekšmetu saraksts / {{list.title}}</h1>
      </header>
      <div class="content">
        <div class="main">
          <div class="section">
            <div class="sectionTitle">Priekšmetu saraksts</div>
            <div class="sectionContent">
              <div class="actions" v-if="hasEditPermission(user.id)">
                <items-search-component></items-search-component>
              </div>
              <table class="table">
                <thead class="bg-light">
                <tr>
                  <th>Attēls</th>
                  <th>Numurs</th>
                  <th>Nosaukums</th>
                  <th>Kolekcija</th>
                  <th>Apraksts</th>
                  <th>Darbības</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td style="width:120px;"><img v-if="item.featured_image != null" :src="'/image/'+item.featured_image.file_name"></td>
                  <td style="width:120px;">
                    {{item.cipher}} {{item.item_number}}<span v-if="item.item_subnumber">-{{item.item_subnumber}}</span>
                  </td>
                  <td><span v-if="item.title">{{item.title.title}}</span></td>
                  <td><span v-if="item.collection">{{item.collection.title}}</span></td>
                  <td>{{item.description}}</td>
                  <td>
                    <div class="actions">
                      <item-view-component
                          :key="'view-component-'+item.id"
                          :item="item"
                          :transfer_types="transfer_types"
                          :settings="settings"
                          :item_titles="item_titles"
                          :item_collections="item_collections"
                          :scientific_themes="scientific_themes"
                          :ciphers="ciphers"
                          :user="user"
                          :copyrights="copyrights"
                      ></item-view-component>
                      <div v-if="hasEditPermission(user.id)" @click="removeFromList(item.id)" class="delete" ><span class="material-icons">close</span></div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
              <div v-if="items.length === 0" class="alert alert-info text-center">Sarakstā nav neviens priekšmets. Izmantojiet <strong>priekšmetu meklētāju</strong>, lai meklētu un pievienotu jaunus priekšmetus.</div>

            </div>
          </div>
        </div>
        <div class="sidebar">
            <div class="section">
              <div class="sectionTitle">Pamatinformācija</div>
              <div class="sectionContent" v-if="isListAuthor(user.id)">
                <div class="form-group">
                  <label for="title">Nosaukums</label>
                  <input type="text" class="form-control" v-model="title">
                </div>
                <div class="form-group text-right">
                  <button class="btn btn-primary" @click="updateTitle()">Saglabāt</button>
                </div>
              </div>
              <div class="sectionContent" v-else>
                <div class="form-group">
                  <label for="title">Nosaukums</label>
                  <input type="text" class="form-control" v-model="title" disabled>
                </div>
              </div>
            </div>
          <div class="section">

            <div class="sectionTitle">Lietotāju piekļuves</div>
            <div class="sectionContent">
              <div v-if="isListAuthor(user.id)" class="form-group text-center">
                <button class="btn btn-primary" data-toggle="modal" :data-target="'#modal-permissions'">Piekļuves pārvaldība</button>
                <hr>
              </div>
              <div v-if="isListAuthor(user.id)" class="modal fade" tabindex="-1"  :id="'modal-permissions'" ref="vuemodal">
                <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                      <h5 class="modal-title">Piekļuves pārvaldība</h5>
                      <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label for="filter">Filtrs</label>
                            <input type="text" class="form-control" v-model="userFilter">
                          </div>
                        </div>
                        <div class="col-12 usersTable">
                          <table class="table">
                            <thead class="bg-primary text-white sticky-top">
                              <tr>
                                <th>Lietotājs</th>
                                <th>Skatīt sarakstu</th>
                                <th>Labot sarakstu</th>
                              </tr>
                            </thead>
                            <tbody>
                            <tr class="person" v-for="user in filteredUsers" :key="user.id">
                              <td><strong>{{user.firstname}} {{user.lastname}}</strong></td>
                              <td>
                                <div v-if="users_can_view.includes(user.id)" class="switch" :class="{'active': (users_can_view.includes(user.id))}" @click="changePermission('remove','can_view', user.id, list.id)"><span class="circle"></span></div>
                                <div v-else class="switch" @click="changePermission('add','can_view', user.id, list.id)"><span class="circle"></span></div>
                              </td>
                              <td>
                                <div v-if="users_can_edit.includes(user.id)" class="switch" :class="{'active': (users_can_edit.includes(user.id))}" @click="changePermission('remove','can_edit', user.id, list.id)"><span class="circle"></span></div>
                                <div v-else class="switch" @click="changePermission('add','can_edit', user.id, list.id)"><span class="circle"></span></div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group text-center">
                <a :href="'/researcher/show/'+list.id+'/generateItemsList'" class="btn btn-primary" target="_blank">Priekšmetu saraksts</a>
                <hr>
              </div>
              <div class="form-group text-center" v-if="isListAuthor(user.id)">
                <a @click="deleteList(list.id)" class="btn btn-danger">Dzēst sarakstu</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default{
    props:['all_users_list','list_prop','user','transfer_types','settings','item_titles','item_collections','scientific_themes','ciphers','copyrights'],
    mounted(){
        var that = this;
        this.items = this.$props.list_prop.items;
        this.title = this.$props.list_prop.title;
        this.list = this.$props.list_prop;
        EventBus.$on('add_item_to_list',item_id =>{
           axios.post('/researcher/add-item-to-list/'+that.list.id,
            {
                item_id: item_id
            }).then(response =>{
               if(response.data.status == 'ok')
               {
                   that.items = response.data.list.items;
                   that.$toast.open(response.data.message);
               }
               if(response.data.status == 'info')
               {
                   that.$toast.warning(response.data.message);
               }
               if(response.data.status == 'error')
               {
                   that.$toast.warning(response.data.message);
               }
           });
        });

        EventBus.$on('add_items_to_list',items_ids =>{
            axios.post('/researcher/add-items-to-list/'+that.list.id,
                {
                    items_ids: items_ids
                }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.items = response.data.list.items;
                    that.$toast.open(response.data.message);
                }
                if(response.data.status == 'info')
                {
                    that.$toast.warning(response.data.message);
                }
                if(response.data.status == 'error')
                {
                    that.$toast.warning(response.data.message);
                }
            });
        });

        EventBus.$on('open_next_item_view_modal', (current_item_id) =>{
            that.openNextItemViewModal(current_item_id);
        });
        EventBus.$on('open_prev_item_view_modal', (current_item_id) =>{
            that.openPrevItemViewModal(current_item_id);
        });

    },
    data()
    {
        return{
            loading:false,
            items:[],
            title:"",
            list:[],
            userFilter:"",
        }
    },
    methods: {
        changePermission(action,permission_type, user_id, list_id)
        {
          var that = this;
          axios.post('/researcher/change-list-permissions/'+that.list.id,{
            'user_id': user_id,
            'action': action,
            'permission_type': permission_type
          })
              .then(response => {
                if(response.data.status == 'ok')
                {
                  that.list = response.data.list;
                  that.$toast.open(response.data.message);
                }
              })
        },
        openPrevItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)-1;
            if(index >= 0)
            {
                $('#view-'+this.items_list[index+1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else {
                $('#view-'+this.items_list[index+1]).modal('hide');
                if(this.pagination.current_page - 1 >0)
                {
                    this.search(this.pagination.current_page-1);
                }

            }
        },
        openNextItemViewModal(item_id)
        {
            var index = this.items_list.findIndex(item => item === item_id)+1;
            if(index < this.items_list.length)
            {
                $('#view-'+this.items_list[index-1]).modal('hide');
                $('#view-'+this.items_list[index]).modal('show');
            }
            else{
                $('#view-'+this.items_list[index-1]).modal('hide');
            }
        },
        updateTitle()
        {
          var that = this;
          axios.post('/researcher/update/'+that.list.id,{
            title: that.title,
          }).then(response => {
            if(response.data.status == 'ok')
            {
              that.title = response.data.list.title;
              that.items = response.data.list.items;
              that.list = response.data.list;
              that.$toast.open(response.data.message);
            }
            else
            {
              that.$toast.error(response.data.message);
            }
          })
        },
        removeFromList(item_id)
        {
            var that = this;
            that.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst priekšmetu no saraksta?',
                text: "Priekšmets tiks dzēsts no saraksta.",
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#E53935',
                cancelButtonColor: '#888787',
                confirmButtonText: 'Dzēst',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                    if (result.value) {
                        axios.post('/researcher/remove-item-from-list/' + that.list.id,
                            {
                                item_id: item_id
                            }).then(response => {
                            if (response.data.status == 'ok') {
                                that.items = response.data.list.items;
                                that.$toast.open(response.data.message);
                            }
                            if (response.data.status == 'info') {
                                that.$toast.warning(response.data.message);
                            }
                            if (response.data.status == 'error') {
                                that.$toast.warning(response.data.message);
                            }
                        });
                    }});
        },
        deleteList(id)
        {
          var that = this;
          var that = this;
          that.$swal.fire({
            title: 'Vai tiešām vēlaties dzēst pētnieku sarakstu?',
            text: "Saraksts un tam piesaistītie priekšmeti tiks dzēsti.",
            icon: 'error',
            showCancelButton: true,
            confirmButtonColor: '#E53935',
            cancelButtonColor: '#888787',
            confirmButtonText: 'Dzēst',
            cancelButtonText: 'Atcelt'
          }).then((result) => {
            if (result.value) {
              axios.post('/researcher/delete/' + id).then(response => {
                if (response.data.status == 'ok') {
                  that.$toast.open(response.data.message);
                  window.location.replace("/researcher");
                } else {
                  that.$toast.error(response.data.message);
                }
              });
            }});
        },
        hasEditPermission(current_user_id)
        {
          if(this.users_can_edit.includes(current_user_id) || this.list.user_id == current_user_id)
          {
            return true;
          }
          return false;
        },
      isListAuthor(current_user_id)
      {
        if(this.list.user_id == current_user_id)
        {
          return true;
        }
        return false;

      }

    },
    computed:{
        users_can_view: function(user)
        {
          var users = [];
          if(this.list.users)
          {
            this.list.users.forEach(user =>
            {
              if(user.permission_type == 'can_view')
              {
                users.push(user.user_id);
              }
            });
          }
          return users;
        },
        users_can_edit: function(user)
        {
          var users = [];
          if(this.list.users) {
            this.list.users.forEach(user => {
              if (user.permission_type == 'can_edit') {
                users.push(user.user_id);
              }
            });
          }
          return users;
        },
        items_list()
        {
            var that = this;
            if(that.items)
            {
                return that.items.map(item =>{
                    return item.id;
                });

            }
        },
        filteredUsers:function()
        {
          var that = this;
          var filterString = this.userFilter.toLowerCase();
          return this.all_users_list.filter(function(s) {
            if (s.firstname.toLowerCase().includes(filterString) ||
                s.lastname.toLowerCase().includes(filterString) ||
                filterString == ""
            )
            {
              return true;
            }
          });


        }

    }
}
</script>
<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.usersTable
{
  max-height:80vh;
  overflow: auto;
  .switch{
    width:45px;
    height:25px;
    background:#eee;
    border-radius:15px;
    position:relative;
    display:block;
    cursor:pointer;
    .circle{
      position:absolute;
      top:2.5px;
      left:2.5px;
      height:20px;
      width:20px;
      background:#fff;
      border-radius:100%;
      transition:all .2s ease-in-out;
    }
    &.active{
      .circle{
        transform:translateX(17.5px);
        background:$blue;
      }
    }
  }
}
img{
    max-width:100%;
    height:auto;
}
.actions{
    display:flex;
    justify-content: flex-end;
    margin-bottom:20px;
}
.itemActions{
    width:150px;
    display:flex;
    align-items: center;
    justify-content: center;
    .action{
        cursor:pointer;
        padding:15px;
        &.view{
            color:$blue;
        }
        &.delete{
            color:$red;
        }
    }
}


</style>
